module.exports = __webpack_public_path__ + "media/assets/images/flags/pg-a1d66c244fbff97efa186ae0ac20732f.svg";